import { Component } from 'react';
import isEqual from 'lodash/isEqual';

type Props<A extends unknown[]> = {
	args: A;
	// eslint-disable-next-line jira/react/handler-naming
	op: (...args: A) => void;
};

// oxlint-disable-next-line react/prefer-function-component
class OpTrigger<A extends unknown[]> extends Component<Props<A>> {
	static defaultProps: {
		args: never[];
	} = { args: [] };

	componentDidMount(): void {
		this.props.op(...this.props.args);
	}

	shouldComponentUpdate(nextProps: Props<A>): boolean {
		return !isEqual(this.props.args, nextProps.args);
	}

	componentDidUpdate(): void {
		this.props.op(...this.props.args);
	}

	render(): null {
		return null;
	}
}

export default OpTrigger;
